import React, {useState, useEffect} from "react";
import Select from "react-select";
import ReactModal from "react-modal";

import "./RootCauseTwo.css";
import {FileUploadButton} from "../../../../common/button/file-upload-button/FileUploadButton";
import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import problemIcon from "../../../../../resources/images/problem-icon.png";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {createCause} from "../../../../../services/CauseService";
import {updateCause} from "../../../../../services/CauseService";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";
import {CommentToolTip} from "../../../../common/tool-tip-comments/CommentToolTip";
import {FileListItem} from "../../../../common/list/file-list-item/FileListItem";
import {deleteFile} from "../../../../../services/FileService";
import {appBaseURL, downloadURL} from "../../../../../config/URLConfig";

export const RootCauseTwo = ({context, setContext, navigateTo, navigateBack, setSpinnerText, showToaster, toolTipsEnabled}) => {
    ReactModal.setAppElement('#root');


    const [priorityOptions, setPriorityOptions] = useState(null);
    const [priority, setPriority] = useState({label: "Select...", value: null});
    const [file, setFile] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [largeFileList, setLargeFileList] = useState([]);
    const [showFileSizeModal, setShowFileSizeModal] = useState(false);
    const [showDuplicateFileModal, setShowDuplicateFileModal] = useState(false);

    useEffect(() => {
        setPriorityOptions([
            {label: "Low", value: "Low"},
            {label: "Medium", value: "Medium"},
            {label: "High", value: "High"},
        ]);

        if (context.rootCauseScreen) {
            if (context.rootCauseScreen.fileList) {
                setFileList([...context.rootCauseScreen.fileList]);
            }

            if (context.rootCauseScreen.priority) {
                setPriority({...context.rootCauseScreen.priority});
            }
        }
    }, []);

    useEffect(() => {
        if (null !== file) {
            if (!fileList.some(fileInList => fileInList.name === file.name)) {
                setFileList((prevState) => ([...prevState, file]));
            } else {
                setShowDuplicateFileModal(true);
            }
        }
    }, [file]);

    const handleViewFileClick = (fileToView) => {
        window.open(appBaseURL + downloadURL + fileToView.externalReference);
    }

    const handleDeleteFileClick = async (fileToBeRemoved) => {
        if (fileToBeRemoved.externalReference) {
            const [data, error] = await deleteFile(context.username, fileToBeRemoved.externalReference);
            if (data) {
                if (data.responseStatus === "Success") {
                    let copyOfFileList = [...fileList];
                    let index = copyOfFileList.indexOf(fileToBeRemoved);
                    copyOfFileList.splice(index, 1);
                    setFileList([...copyOfFileList]);
                }
                showToaster(data);
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
        } else {
            let copyOfFileList = [...fileList];
            let index = copyOfFileList.indexOf(fileToBeRemoved);
            copyOfFileList.splice(index, 1);
            setFileList([...copyOfFileList]);
        }
    }

    const handleNextClick = async () => {
        const largeFiles = fileList.filter((file) => file.size > 16777216);
        if (largeFiles.length > 0) {
            setLargeFileList(largeFiles);
            setShowFileSizeModal(true);
        } else {
            const rootCause = {
                externalReference: context.rootCauseScreen.externalReference,
                problemExternalRef: context.problemScreen.externalReference,
                name: context.rootCauseScreen.name,
                description: context.rootCauseScreen.description,
                priority: priority.label,
                causeEvidenceList: fileList,
            }

            await saveCause(rootCause);
        }
    }

    const saveCause = async (rootCause) => {
        setSpinnerText("Saving Cause");
        if (!context.rootCauseScreen.externalReference) {
            const [data, error] = await createCause(context.username, rootCause);
            if (data) {
                if (data.responseStatus === "Success") {
                    if (context.viewMode) {
                        setContext((prevState) => ({
                            ...prevState,
                            rootCauseScreen: {
                                ...prevState.rootCauseScreen,
                                externalReference: data.createdCauseVO.externalReference,
                            },
                        }));
                        navigateTo("rootCauseOverview");
                    } else {
                        navigateTo("rootCauseOverview");
                    }
                }
                showToaster(data);
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
        } else {
            const copyOfRootCauseScreen = context.copyOfRootCauseScreen;
            const currentRootCauseScreen = JSON.stringify(context.rootCauseScreen);
            if (copyOfRootCauseScreen === currentRootCauseScreen && context.rootCauseScreen.fileList.length === fileList.length) {
                navigateTo("rootCauseOverview");
            } else {
                rootCause.causeEvidenceList = rootCause.causeEvidenceList.filter((file) => file.data !== "");
                const [data, error] = await updateCause(context.username, rootCause);
                if (data) {
                    if (data.responseStatus === "Success") {
                        if (context.viewMode) {
                            setContext((prevState) => ({
                                ...prevState,
                                rootCauseScreen: {
                                    ...prevState.rootCauseScreen,
                                    externalReference: data.updatedCauseVO.externalReference,
                                },
                            }));
                            navigateTo("rootCauseOverview");
                        } else {
                            navigateTo("rootCauseOverview");
                        }
                    }
                    showToaster(data);
                } else {
                    showToaster({
                        responseStatus: "Error",
                        responseMessage: error.message,
                    });
                }
            }
        }
        setSpinnerText(null);
    }

    const fileListItems = fileList.map((file, index) => {
        return (
            <FileListItem key={index}
                          context={context}
                          text={file.name}
                          showDownloadButton={context.viewMode && file.externalReference}
                          onDownloadClick={() => {
                              handleViewFileClick(file);
                          }}
                          onDeleteClick={() => {
                              handleDeleteFileClick(file)
                          }}
            />
        );
    });

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={problemIcon} alt="Aurum Logo" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.problemScreen.title}</p>
                </div>
                <div className="wizard-right-container">
                    <div className="input-container">
                        <div>
                            <label>Root Cause Prioritisation:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"rootcauseprior123"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Root Cause Prioritisation:"}/>}
                        </div>
                        <Select options={priorityOptions}
                                onChange={(selectedPriority) => {
                                    setPriority(selectedPriority)
                                }}
                                isDisabled={!priorityOptions || !context.editMode}
                                value={{label: priority.label, value: priority.value}}
                                classNamePrefix="select"
                                data-testid="root-cause-prioritisation"
                        />
                    </div>
                    <div className={"label-div-tooltip-"}>
                        <label className="label">Root Cause Tool:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"rootcausetool123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Root Cause Tool:"}/>}
                    </div>
                    {fileListItems}
                    <FileUploadButton buttonText={"Select File"} setFile={setFile}
                                      disableButton={fileList.length > 4 || !context.editMode}/>
                    {context.viewMode && context.rootCauseScreen && context.rootCauseScreen.externalReference &&
                    <CommentToolTip contextName={"Cause"} showToaster={showToaster} setSpinnerText={setSpinnerText}
                                    contextExternalReference={context.rootCauseScreen.externalReference}
                                    context={context} toolTipsEnabled={toolTipsEnabled}/>}
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => {
                            navigateTo("problemTree");
                        }}/>
                    </div>}
                    <div className="navigation-button-container">
                        <NextButton onClick={handleNextClick} disabled={!priority.value}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>

            <ReactModal isOpen={showFileSizeModal} className="modal-content" overlayClassName="modal-overlay">
                <div className="file-warning-modal-content">
                    <p className="modal-title">File Size Warning</p>
                    {largeFileList.length === 1 &&
                    <p className="file-warning-modal-text">
                        The following file is larger than 16MB and cannot be uploaded:
                    </p>}
                    {largeFileList.length > 1 &&
                    <p className="file-warning-modal-text">
                        The following files are larger than 16MB and cannot be uploaded:
                    </p>}
                    {largeFileList.map((file, index) => {
                        return (<p className="file-warning-modal-text" key={index}>{file.name}</p>);
                    })}
                    <div className="modal-button-container">
                        <StandardButton text="Close" onClick={() => {
                            setShowFileSizeModal(false)
                        }}/>
                    </div>
                </div>
            </ReactModal>

            <ReactModal isOpen={showDuplicateFileModal} className="modal-content" overlayClassName="modal-overlay">
                <div className="file-warning-modal-content">
                    <p className="modal-title">Duplicate File</p>
                    <p className="file-warning-modal-text">That file has already been selected</p>
                    <div className="modal-button-container">
                        <StandardButton text="Close" onClick={() => {
                            setShowDuplicateFileModal(false)
                        }}/>
                    </div>
                </div>
            </ReactModal>
        </div>
    );
}
